import React, { useEffect, useState } from 'react';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import {
  KompisSheet,
  KompisSheetHeader,
  KompisSheetBody,
} from '@inter-ikea-kompis/react-components';
import { useDispatch } from 'react-redux';
import ProductList from '../ProductList/ProductList';
import { translate } from '../../services/L10n';
import { actionDequeueAllSheets } from '../../state/sheets/sheetActions';
import { t } from '../../translations';

export const WHATS_INCLUDED = 'WHATS_INCLUDED';

export const WhatsIncludedSheet: React.FC = () => {
  const padding = { padding: '8px 32px 32px 32px' };
  const dispatch = useDispatch();
  const closeAllSheets = () => dispatch(actionDequeueAllSheets());

  const [sheetVisible, setSheetVisible] = useState(true);

  useEffect(() => {
    return () => setSheetVisible(false);
  }, []);

  return (
    <KompisSheet
      onOverlayClick={closeAllSheets}
      visible={sheetVisible}
      theme={SkapaTheme}
    >
      <KompisSheetHeader
        theme={SkapaTheme}
        heading={translate(t.PRODUCT_LIST_HEADLINE)}
        onCloseButtonClick={closeAllSheets}
      />
      <KompisSheetBody theme={SkapaTheme}>
        <div style={padding}>
          <ProductList />
        </div>
      </KompisSheetBody>
    </KompisSheet>
  );
};
